/**
 * LazyChartSection
 * On mobile, only renders children when the section is near the viewport (Intersection Observer).
 * On desktop, always renders children. Reduces initial paint and scroll work on Analytics mobile.
 */
import { useState, useEffect, useRef } from 'react';

const ROOT_MARGIN = '200px';
const THRESHOLD = 0;

export default function LazyChartSection({ isMobile, children }) {
  const [inView, setInView] = useState(!isMobile);
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!isMobile || !sentinelRef.current) return;

    const el = sentinelRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { rootMargin: ROOT_MARGIN, threshold: THRESHOLD }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [isMobile]);

  if (!isMobile) return <>{children}</>;

  return (
    <>
      <div ref={sentinelRef} style={{ minHeight: 1, marginTop: -1 }} aria-hidden="true" />
      {inView ? children : null}
    </>
  );
}
